/* eslint-disable @typescript-eslint/no-explicit-any */
import MUIDataTable from "mui-datatables";
import { Vocabulary } from "../../Utils/Vocabulary";
import { CircularProgress, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import moment from "moment";
import { LocalUrlEnum, UrlEnum } from "../../Utils/Utils";
import theme from "../../Theme/Theme";
import { getData } from "../../Services/getData";
import { toast } from "react-toastify";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function CustomersOrders() {
  const navigate = useNavigate();
  const location = useLocation();
  const matches = useMediaQuery("(max-width:850px)");

  const notifyError = (message: string) => toast.error(message);
  const userEmail = localStorage.getItem("email");
  const [loading, setLoading] = useState(false);
  const [orderStatuses, setOrderStatuses] = useState<any>([]);
  const [state, setState] = useState<any>({
    orders: [],
    orderNumber: 0,
    page: 0,
    perPage: 50,
  });

  useEffect(() => {
    getOrderStatuses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  /**
   *
   */
  useEffect(() => {
    const encodeSearch = decodeURI(location.search);
    const search = encodeSearch.split(/[?&]/);
    const newState = Object.assign({}, state);
    newState.forPayment = false;
    search.forEach((value) => {
      if (value !== "") {
        const values = value.split("=");
        if (values[0] === "page") {
          newState[values[0]] = +values[1] - 1;
        } else {
          newState[values[0]] = isNaN(+values[1]) ? values[1] : +values[1];
        }
      }
    });
    getOrders(newState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  /**
   *
   */
  async function getOrderStatuses() {
    getData(UrlEnum.orderStatus).then((res) => {
      if (res && res.data) {
        setOrderStatuses(res.data);
      }
    });
  }
  /**
   *
   * @param newState
   */
  async function getOrders(newState: any) {
    setLoading(true);
    let url = `${UrlEnum.orders}/byCustomer/${userEmail}/${
      newState.page ? newState.page : 0
    }/${newState.perPage ? newState.perPage : state.perPage}`;
    if (newState.search) {
      url += `/${newState.search}`;
    }
    await getData(url)
      .then((res) => {
        setState({
          ...state,
          orders: res.data.orders,
          orderNumber: res.data.ordersNumber,
          page: newState.page ? newState.page : 0,
          perPage: newState.perPage ? newState.perPage : state.perPage,
        });
        setLoading(false);
      })
      .catch((err) => {
        notifyError(Vocabulary.getError);
        setLoading(false);
      });
  }

  /**
   *
   */
  const requestHeaders = [
    {
      label: Vocabulary.numberOrder,
      name: "orderNumber",
      options: {
        customBodyRender: (orderNumber: any, tableMeta: any) => {
          return <Typography>{orderNumber}</Typography>;
        },
      },
    },
    {
      label: Vocabulary.deviceName,
      name: "deviceDetails",
      options: {
        sort: true,
        customBodyRender: (deviceDetails: any, tableMeta: any) => {
          return <Typography>{deviceDetails ? deviceDetails?.deviceName : ""}</Typography>;
        },
      },
    },
    {
      label: Vocabulary.status,
      name: "status",
      options: {
        sort: true,
        customBodyRender: (status: any, tableMeta: any) => {
          return <Typography>{status.order}</Typography>;
        },
      },
    },
    ...(matches
      ? []
      : [
          {
            label: Vocabulary.date,
            name: "createdAt",
            options: {
              sort: true,
              customBodyRender: (value: any, tableMeta: any) => {
                return (
                  <Typography>
                    {moment(value).format("DD-MM-YYYY HH:mm")}
                  </Typography>
                );
              },
            },
          },
        ]),
  ];

  /**
   *
   * @returns
   */
  function getTableOptions() {
    const responsive: "standard" | "vertical" | "simple" | undefined = "simple";
    return {
      selectableRows: "none" as any,
      viewColumns: false as any,
      responsive: responsive,
      rowsPerPageOptions: [10, 20, 50, 100, 200],
      confirmFilters: false,
      filter: false,
      print: false,
      download: false,
      textLabels: {
        body: {
          noMatch: Vocabulary.noResultsFound,
        },
      },
      count: state.orderNumber,
      rowsPerPage: state.perPage,
      page: state.page,
      search: true,
      serverSide: true,
      sort: true,
      onRowClick: (rowData: any, rowMeta: any) => {
        const clickedOrder = state.orders[rowMeta.dataIndex];
        navigate(`${LocalUrlEnum.customerOrders}${clickedOrder._id}`);
      },
      setRowProps: (row: any, dataIndex: any, rowIndex: any) => {
        const status = orderStatuses.find(
          (s: any) => s.name === state.orders[rowIndex]?.status?.order
        );
        if (status) {
          return {
            style: {
              backgroundColor: status.color,
              cursor: "pointer",
            },
          };
        }
        return {
          style: {
            backgroundColor: theme.palette.grayColor?.main,
            cursor: "pointer",
          },
        };
      },
      onChangePage: (page: any) => {
        if (state.search)
          navigate(
            `?page=${page + 1}?perPage=${state.perPage}?search=${state.search}`
          );
        else navigate(`?page=${page + 1}?perPage=${state.perPage}`);
        window.scrollTo(0, 0);
      },
      /**
       *
       * @param numberOfRows
       */
      onChangeRowsPerPage: (numberOfRows: number) => {
        if (state.search)
          navigate(`?page=${1}?perPage=${numberOfRows}?search=${state.search}`);
        else navigate(`?page=${1}?perPage=${numberOfRows}`);
        window.scrollTo(0, 0);
      },
      /**
       *
       * @param search
       */
      onSearchChange: async (search: string | null) => {
        if (search) {
          navigate(
            `?page=${state.page + 1}?perPage=${state.perPage}?search=${search}`
          );
        } else {
          navigate(`?page=${state.page + 1}?perPage=${state.perPage}`);
        }
      },
      /**
       *
       */
      onSearchClose: async () => {
        navigate(`?page=${state.page + 1}?perPage=${state.perPage}`);
      },
    };
  }

  return (
    <div>
      <MUIDataTable
      
        title={Vocabulary.orders}
        data={state.orders}
        columns={requestHeaders}
        options={getTableOptions()}
      />
      {loading ? (
        <div className="loading">
          <CircularProgress color="primary" />
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
